import { useEffect, useRef, useState } from "react";
import Aside from "../components/Aside";
import Adminstor from "../components/Adminstor";
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

const DASHBOARD_PAGE = "تابلو";
const NEW_TRADES_PAGE = "تراکنش جدید";

function Admin() {
  const [selected, setSelected] = useState(DASHBOARD_PAGE);
  const [pendingCount, setPendingCount] = useState(0);
  const [tradeAlert, setTradeAlert] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const prevCountRef = useRef(null);
  const soundRef = useRef(null);

  useEffect(() => {
    soundRef.current = new Audio("/Notif.mp3");
  }, []);

  useEffect(() => {
    const checkNewTrades = async () => {
      try {
        const response = await fetch(apiUrl("/api/trades/pending"), {
          headers: adminAuthHeaders(),
        });
        const data = await response.json();

        if (!data.success || !Array.isArray(data.trades)) {
          return;
        }

        const newCount = data.trades.length;
        const prevCount = prevCountRef.current;

        if (prevCount === null) {
          prevCountRef.current = newCount;
          setPendingCount(selected === NEW_TRADES_PAGE ? 0 : newCount);
          return;
        }

        if (newCount > prevCount) {
          const newTradesCount = newCount - prevCount;

          if (soundRef.current) {
            soundRef.current.currentTime = 0;
            soundRef.current.play().catch(() => {});
          }

          if (selected !== NEW_TRADES_PAGE) {
            if ("Notification" in window && Notification.permission === "granted") {
              new Notification("تراکنش جدید!", {
                body: `${newTradesCount} تراکنش جدید در انتظار تایید است`,
                icon: "/favicon.ico",
                tag: "new-trade",
              });
            }

            setTradeAlert({
              newTradesCount,
              totalCount: newCount,
            });
          }
        }

        prevCountRef.current = newCount;
        setPendingCount(selected === NEW_TRADES_PAGE ? 0 : newCount);
      } catch (error) {
        console.error("Error checking trades:", error);
      }
    };

    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }

    checkNewTrades();
    const interval = setInterval(checkNewTrades, 5000);

    return () => clearInterval(interval);
  }, [selected]);

  const handleSelect = (page) => {
    setSelected(page);
    setMobileMenuOpen(false);

    if (page === NEW_TRADES_PAGE) {
      setPendingCount(0);
      setTradeAlert(null);
    }
  };

  const handleAlertAction = () => {
    setSelected(NEW_TRADES_PAGE);
    setPendingCount(0);
    setTradeAlert(null);
  };

  return (
    <>
      <div className="AdminPage">
        <button
          type="button"
          className={`AdminMobileMenuButton ${mobileMenuOpen ? "is-open" : ""}`}
          onClick={() => setMobileMenuOpen((isOpen) => !isOpen)}
          aria-label={mobileMenuOpen ? "Close admin menu" : "Open admin menu"}
          aria-expanded={mobileMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        {mobileMenuOpen && (
          <button
            type="button"
            className="AdminMobileMenuBackdrop"
            aria-label="Close admin menu"
            onClick={() => setMobileMenuOpen(false)}
          />
        )}

        <Aside
          onSelect={handleSelect}
          selected={selected}
          pendingCount={pendingCount}
          isMobileOpen={mobileMenuOpen}
        />
        <Adminstor selected={selected} />
      </div>

      {tradeAlert && selected !== NEW_TRADES_PAGE && (
        <div className="admin-alert-overlay" onClick={() => setTradeAlert(null)}>
          <div className="admin-alert-modal" onClick={(event) => event.stopPropagation()}>
            <div className="admin-alert-badge">تراکنش جدید</div>
            <h3>درخواست جدید ثبت شد</h3>
            <p>{tradeAlert.newTradesCount} تراکنش جدید به صف تایید اضافه شده است.</p>
            <span>مجموع تراکنش‌های در انتظار: {tradeAlert.totalCount}</span>
            <div className="admin-alert-actions">
              <button type="button" className="admin-alert-secondary" onClick={() => setTradeAlert(null)}>
                بستن
              </button>
              <button type="button" className="admin-alert-primary" onClick={handleAlertAction}>
                مشاهده تراکنش‌ها
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Admin;
